export default __webpack_public_path__ + "static/media/exam.e39dc4fe.jpg";